<template>
  <div class="metode-pembuatan-radio">
    <label class="section-label">Metode Pembuatan <span class="required">*</span></label>
    <a-radio-group
      :value="modelValue"
      class="radio-group-vertical"
      :disabled="disabled"
      @change="handleChange"
    >
      <div class="radio-option-wrapper">
        <a-radio value="Buat di Sistem">Buat di Sistem</a-radio>
        <p class="radio-description">
          Buat surat menggunakan editor di sistem ini. Surat akan digenerate otomatis menjadi PDF.
        </p>
      </div>

      <div class="radio-option-wrapper">
        <a-radio value="Upload File">Upload File</a-radio>
        <p class="radio-description">
          Upload file surat yang sudah jadi dari luar sistem (PDF, PNG, atau JPG/JPEG).
        </p>
      </div>
    </a-radio-group>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MetodePembuatanRadio',
  props: {
    modelValue: {
      type: String,
      default: 'Buat di Sistem',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const handleChange = (e) => {
      emit('update:modelValue', e.target.value)
    }

    return {
      handleChange,
    }
  },
})
</script>

<style lang="scss" scoped>
.metode-pembuatan-radio {
  margin-bottom: 24px;

  .section-label {
    display: block;
    font-weight: 500;
    color: #262626;
    margin-bottom: 8px;
    font-size: 14px;

    .required {
      color: #ff4d4f;
    }
  }

  /* Styling for the wrapper div to handle spacing */
  .radio-option-wrapper {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    /* Move the description below the radio and indent it */
    .radio-description {
      font-size: 12px;
      color: #8c8c8c;
      /* 24px margin-left accounts for the radio circle width + gap */
      margin: 4px 0 0 24px;
      line-height: 1.5;
      white-space: normal; /* Force text wrapping */
    }
  }

  /* Radio Group Layout */
  .radio-group-vertical {
    display: flex;
    flex-direction: column;
    width: 100%; /* Ensure it takes full width */
  }

  /* --- Ant Design Overrides --- */

  /* 1. The border color when selected */
  :deep(.ant-radio-checked .ant-radio-inner) {
    border-color: #E10F28 !important;
  }

  /* 2. The inner dot color when selected */
  :deep(.ant-radio-checked .ant-radio-inner::after) {
    background-color: #E10F28 !important;
  }

  /* 3. The border color on hover */
  :deep(.ant-radio-wrapper:hover .ant-radio .ant-radio-inner),
  :deep(.ant-radio:hover .ant-radio-inner) {
    border-color: #E10F28 !important;
  }

  /* 4. Focus glow */
  :deep(.ant-radio-input:focus + .ant-radio-inner) {
    box-shadow: 0 0 0 3px rgba(225, 15, 40, 0.2);
  }

  /* 5. Ensure radio wrapper allows wrapping if needed (extra safety) */
  :deep(.ant-radio-wrapper) {
    white-space: normal;
  }
}
</style>
